import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translate';
import './Shop.css';

const Shop = () => {
  const { language } = useLanguage();
  
  const shops = [
    {
      id: 1,
      nameKey: 'shop.shops.airport',
      image: '/images/store.jpg',
      alt: 'New Chitose Airport Store',
      address: '北海道千岁市美々Bibi,chityose,hokkaido',
      tel: '080-3294-1093'
    },
    {
      id: 2,
      nameKey: 'shop.shops.sapporo',
      image: '/images/store.jpg',
      alt: 'Sapporo Station Store',
      address: '札幌市北区北6条西4丁目',
      tel: '080-3294-1093'
    }
  ];

  const stepsToAirport = [
    {
      titleKey: 'shop.toAirportDesc1',
      descriptionKey: 'shop.toAirportDesc2'
    }
  ];

  const stepsFromShop = [
    {
      titleKey: 'shop.fromShopDesc1',
      descriptionKey: 'shop.fromShopDesc2'
    }
  ];

  return (
    <div className="shop-page">
      {/* 当前位置指示器 */}
      <div className="position">
        <span>{t('shop.position', language)}</span>
        <Link to="/">{t('common.daydaygo', language)}</Link>
        <span>{t('common.greaterThan', language)}{t('shop.shopTitle', language)}</span>
      </div>

      {/* 主要内容区域 */}
      <div className="about-bg" style={{ paddingTop: '50px' }}>
        <div className="title">
          <p className="name">{t('shop.shopTitle', language)}</p>
        </div>

        {/* 店铺列表 */}
        {shops.map(shop => (
          <div key={shop.id} className="shop-table">
            <p className="left">
              <img src={shop.image} width="447" height="236" alt={t(shop.nameKey, language)} />
            </p>
            <p className="right">
              <span className="name">{t(shop.nameKey, language)}</span>
              <span className="txt">
                {t('shop.address', language)}{shop.address}
              </span>
              <span className="txt">
                {t('shop.tel', language)}{shop.tel}
              </span>
              {/* <span className="txt">
                郵便：{shop.postal}
              </span> */}
            </p>
          </div>
        ))}

        {/* 服务说明 */}
        <div className="about-service">
          <p>{t('shop.serviceDesc1', language)}</p>
          <p className="txt">{t('shop.serviceDesc2', language)}</p>
        </div>

        {/* 行き　空港からご出発 */}
        <div className="title">
          <p className="name">{t('shop.toAirport', language)}</p>
        </div>

        {stepsToAirport.map((step, index) => (
          <div key={index} className="guide-line" style={{ width: '945px' }}>
            <p className="txt5">
              <span className="name3">{t(step.titleKey, language)}</span>
              {step.descriptionKey && <span className="content">{t(step.descriptionKey, language)}</span>}
            </p>
          </div>
        ))}

        {/* 帰り　店舗へご返却 */}
        <div className="title">
          <p className="name">{t('shop.fromShop', language)}</p>
        </div>

        {stepsFromShop.map((step, index) => (
          <div key={index} className="guide-line" style={{ width: '945px' }}>
            <p className="txt5">
              <span className="name3">{t(step.titleKey, language)}</span>
              {step.descriptionKey && <span className="content">{t(step.descriptionKey, language)}</span>}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shop;
